'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'membership_benefits',

    viewClass: require('./view'),

    isEnabled() {
        return Odigeo.Membership.enabledSpecialPrimeWidgets;
    },
});
